<img class="preview-image" [src]="selectedOffer.pictures[0]" alt="preview image">
<div class="offer-info">
  <div class="info-text" id="header">{{selectedOffer.area | translatedb}}</div>
  <div class="info-text">{{selectedOffer.subType | translatedb}}</div>
  <div class="info-text">{{ 'SPACE' | translate | lowercase}}: {{selectedOffer.space}} кв.м
  </div>
  <div
    class="info-text">{{offersService.getConvertedPrice(selectedOffer.price)}} {{offersService.selectedCurrency | translate}}
  </div>

</div>
<div class="see-more">
  {{ 'SEE_MORE' | translate | lowercase}}
</div>
<div class="close-button" (click)="closePreview()"></div>
